import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import CardFenomene from './../../../fenomene_selection/components/CardFenomene';
import { MONTHS_SHORT, TIME_SELECTION_CONTAINER } from './../../../../../constants/strings/StringsDashboard';
import ButtonBox from './ButtonBox'
import './cliente.css';

class MonthSelect extends Component {
    render() {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <CardFenomene
                        title={TIME_SELECTION_CONTAINER.MONTH}
                        groupbutton={
                            MONTHS_SHORT.map((data, i) =>
                            <Grid className="iconContainerFS" key={'month-grid-' + i} >
                                <ButtonBox
                                    className="month"
                                    value={data}
                                    id={i+1}
                                    group="month"
                                >
                                    {data}
                                </ButtonBox>
                            </Grid>
                            )}
                    />
                </Grid>
            </Grid>
        )
    }
}

export default MonthSelect;
